// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationNotes-cls1_4Oh","cls2":"TranslationNotes-cls2_Aa5 TranslationNotes-cls1_4Oh"};